import { render, staticRenderFns } from "./ShopsFilter.vue?vue&type=template&id=107d4324&scoped=true"
import script from "./ShopsFilter.vue?vue&type=script&lang=js"
export * from "./ShopsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107d4324",
  null
  
)

export default component.exports